import { Paragraph, Text } from "@/atoms"

import styles from "./Code.module.scss"

import type { CommandSnippetProps } from "."

export const CommandSnippet: React.FC<CommandSnippetProps> = (props) => {
  const { comment, instruction, commands, copyText, onCopy } = props

  return (
    <div>
      {!!comment && <p className={styles.comment}>{comment}</p>}
      <Paragraph
        className={styles.paragraphCopyable}
        ellipsis={{ rows: 3 }}
        copyable={{
          onCopy,
          text: copyText
        }}
      >
        <Text className={styles.instruction}>{instruction}</Text>
        {commands}
      </Paragraph>
    </div>
  )
}
